import { apiClient } from "../../apiClient";

export interface Document {
  id: string;
  filePath: string;
  docsType: string;
  documentNumber?: string;
  expireDate: string | null;
  isRequired: boolean;
  customerId: string;
}

export interface UpdateDocumentRequest {
  docsType?: string;
  documentNumber?: string;
  expireDate?: string;
  file?: File;
}

export const documentService = {
  updateDocument: async (
    documentId: string,
    data: UpdateDocumentRequest,
  ): Promise<Document> => {
    const formData = new FormData();

    if (data.docsType) {
      formData.append("docsType", data.docsType);
    }
    if (data.documentNumber) {
      formData.append("docsNumber", data.documentNumber);
    }
    if (data.expireDate) {
      formData.append("expiresAt", data.expireDate);
    }
    if (data.file) {
      formData.append("file", data.file);
    }

    const response = await apiClient.put(`/documents/${documentId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.data;
  },

  getCustomerDocuments: async (customerId: string): Promise<Document[]> => {
    const response = await apiClient.get(`/customers/${customerId}/documents`);
    return response.data.data;
  },
};
